import { Card, CardContent } from '@mui/material';
import { useTranslationForm } from '../hooks/useTranslationForm';
import TranslationForm from './TranslationForm';
import UrlSelectionStep from './UrlSelectionStep';
import TranslationProgress from './TranslationProgress';
import TranslationResults from './TranslationResults';

export default function TranslationContainer() {
  const form = useTranslationForm();

  return (
    <Card>
      <CardContent>
        {form.step === 'form' && (
          <TranslationForm
            onSubmit={form.submitForm}
            isLoading={form.isCheckingUrls}
          />
        )}

        {form.step === 'selection' && (
          <UrlSelectionStep
            urlCheckResults={form.urlCheckResults}
            selectedUrls={form.selectedUrls}
            onToggle={form.toggleUrl}
            onSelectAll={form.selectAll}
            onDeselectAll={form.deselectAll}
            onContinue={form.startTranslation}
            onCancel={form.cancel}
            isLoading={form.isStartingTranslation}
          />
        )}

        {form.step === 'progress' && form.jobId && (
          <TranslationProgress
            jobId={form.jobId}
            onComplete={form.goToResults}
            onCancel={form.cancel}
          />
        )}

        {form.step === 'results' && form.jobId && (
          <TranslationResults
            jobId={form.jobId}
            onNewTranslation={form.reset}
          />
        )}
      </CardContent>
    </Card>
  );
}
